import { getMessages } from '../../../../../store/constants';

export const PRO_FEATURE_INDICATOR_TITLE = getMessages().getText('pro_feature_indicator.title');
